export default {
  size_0: 11,
  size_1: 13,
  size_2: 15,
  size_3: 17,
  size_4: 19,
  size_5: 21,
  title: 40,
};
